import { useState } from 'react';
import { API_CONFIG } from '../config/apiConfig';
import { apiClient } from '../utils/apiClient';

interface CreateLocatorParams {
  p_user_id: string;
  p_organization_name: string;
  p_subinventory: string;
  p_pallet: string;
  p_cage: string;
  p_tote: string;
}

interface CreateLocatorResponse {
  success: boolean;
  return_status: string;
  return_message: string;
  concatenated_segments: string;
}

export const useCreateLocator = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createLocator = async (params: CreateLocatorParams): Promise<string | null> => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.CREATE_LOCATOR, {
        params
      });

      if (response.data.success && response.data.return_status === 'S') {
        return response.data.concatenated_segments;
      } else {
        const errorMsg = response.data.return_message || response.data.error || 'Create locator failed';
        setError(errorMsg);
        console.error('Create locator failed:', errorMsg);
        return null;
      }
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || err.message || 'Failed to create locator';
      setError(errorMessage);
      console.error('Create locator error:', errorMessage);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    createLocator,
    loading,
    error
  };
};